import { Symptom } from "@/modules/patients/detail/therapy-prescription/de/services/__generated__/useDeCreateTherapyPrescriptionMutation.graphql"

export const SYMPTOMS: Array<Symptom> = [
  "PAIN",
  "PAIN_RELATED_MAL_POSITION",
  "LIMITED_RANGE_OF_MOTION",
  "FUNCTIONAL_DISORDER",
]
